export default __webpack_public_path__ + "static/media/sun.ca4f8a3a.svg";